module.exports = __webpack_public_path__ + "static/media/Salernitana.87b16e84.png";